import { Td } from '../ResumoProducao/styles'
import { Tr } from '@chakra-ui/table'
import React from 'react'
import { Flex, Text, Tooltip } from '@chakra-ui/react'
import { Modal } from './components/Modal'
import { format } from 'date-fns'
import { DrawerObs } from './components/DrawerObs'
import { UsageButton } from '../ImpressaoNota/components/UsageButton'

export function Row({ item, index, itensFaltantes, isVendedor }) {
  function firstLetterUpper(string) {
    return string?.length > 8
      ? string?.charAt(0).toUpperCase() + string?.slice(1).toLowerCase().substring(0, 8) + '...'
      : string?.charAt(0).toUpperCase() + string?.slice(1).toLowerCase()
  }

  const shipping = {
    TRANSPORTADORA: 'TR',
    MotoBoy: 'MB',
    'CLIENTE RETIRA AS 8h30': 'CR 08h:30',
    'NOSSO CARRO 8H30': 'NC 8H30',
    'NOSSO CARRO 17': 'NC 8H30',
  }

  return (
    <Tr key={index}>
      <Td>
        <Flex flexDir="column" gap={2} alignItems="center">
          <Text
            as={'a'}
            color={item.link_layout === '' || !item.link_layout ? 'red.500' : 'blue.500'}
            href={item.link_layout}
            _hover={{ textDecoration: 'underline', filter: 'brightness(0.8)' }}
            target="_blank"
            rel="noreferrer"
            cursor="pointer"
          >
            {firstLetterUpper(item.numero_pedido)}
          </Text>

          <DrawerObs item={item} />
        </Flex>
      </Td>
      <Td>
        <Tooltip label={item?.observacao_entrega} hasArrow>
          <Text>{item.observacao_entrega?.substring(0, 10).concat('...')}</Text>
        </Tooltip>
      </Td>
      <Td>{firstLetterUpper(item.codigo_produto)}</Td>
      <Td>
        <Modal
          item={item}
          // onClick={() => handleItem(item.numero_pedido)}
          itemFaltante={itensFaltantes}
        />
      </Td>
      <Td>
        <Tooltip label={item?.descricao_produto}>
          <Text>{firstLetterUpper(item.descricao_produto.substring(0, 10).concat('...'))}</Text>
        </Tooltip>
      </Td>
      <Td>{firstLetterUpper(item.cor)}</Td>
      <Td>{firstLetterUpper(item.quantidade_negociada)}</Td>

      <Td>
        <Flex flexDir="column" alignItems="center" gap={1}>
          <Text as="span">
            <Tooltip label={item.passo_atual}>{firstLetterUpper(item.passo_atual)}</Tooltip>
          </Text>
          <Text as="span">{item.data_passo_atual}</Text>
        </Flex>
      </Td>
      <Td>
        <Tooltip label={item?.proximo_passo}>{firstLetterUpper(item.proximo_passo)}</Tooltip>
      </Td>
      <Td>{firstLetterUpper(item.prazo_entrega) + ' dias'}</Td>
      <Td textAlign="center">{item.dt_material_pronto ? format(new Date(item.dt_material_pronto), 'dd/MM/yyyy HH:mm') : ''}</Td>
      {!isVendedor && <Td textAlign="center">{item.limite_producao ? format(new Date(item.limite_producao), 'dd/MM/yyyy') : ''}</Td>}
      {isVendedor && <Td textAlign="center">{item.data_saida}</Td>}
      <Td color={item.expedicao > 3 && 'red.500'}>{firstLetterUpper(item.expedicao) + ' dias'}</Td>
      <Td>
        <Tooltip label={item?.entrega} hasArrow>
          <Text>{shipping[item.entrega]}</Text>
        </Tooltip>
      </Td>
      <Td paddingInline=".3rem" textAlign="center" width="200px">
        <Flex align="center" width="100%" justifyContent="space-between">
          {item?.valida_tracken && (
            <UsageButton link={`${process.env.REACT_APP_BASE_URL}/site/v2/tracken/verifica-etiqueta-tracken/${item?.numero_pedido}`} text="Tracken" />
          )}
          {item?.codigo_kangu !== '0' && (
            <UsageButton
              link={`${process.env.REACT_APP_BASE_URL}/site/v2/frete-transp-kangu/visualiza-etiqueta-kangu/${item?.codigo_kangu}`}
              text="Etqt. Kangu"
              isKangu
            />
          )}

          {item?.valida_etiqueta === 'S' && (
            <UsageButton
              link={`${process.env.REACT_APP_BASE_URL}/site/v2/orcamento/visualiza-etiqueta-nfe/${item?.numero_nota}`}
              text="Etqt. Endereço"
            />
          )}
          {/* https://api.innovationbrindes.com.br/api/site/v2/orcamento/visualiza-nota-fisc-fisc/192519 */}
          <UsageButton link={`${process.env.REACT_APP_BASE_URL}/site/v2/orcamento/visualiza-etiquetas/${item?.numero_nota}`} text="Etiqueta" />
          <UsageButton link={`${process.env.REACT_APP_BASE_URL}/site/v2/orcamento/visualiza-nota-fisc/${item?.numero_nota}`} text="Nota" />

          {item?.boletos?.length > 0 && (
            <UsageButton
              // link={`${process.env.REACT_APP_BASE_URL}/site/v2/orcamento/visualiza-nota-fisc/${data?.numero_nota}`}
              text={`${item?.boletos?.length > 1 ? 'Boletos' : 'Boleto'}` + ` (${item?.boletos?.length})`}
              // onClick={() => openTabs(item?.boletos)}
            />
          )}

          {/* <Boletos boletos={data?.boletos} idx={idx} /> */}

          <UsageButton link={`${process.env.REACT_APP_BASE_URL}/site/v2/orcamento/visualiza-xml/${item?.numero_nota}`} text="XML" />
          {item?.remessa === '' ? (
            <></>
          ) : (
            <>
              <UsageButton link={`${process.env.REACT_APP_BASE_URL}/site/v2/orcamento/visualiza-nota-fisc/${item?.nota_remessa}`} text="Remessa" />
              <UsageButton link={`${process.env.REACT_APP_BASE_URL}/site/v2/orcamento/visualiza-xml/${item?.nota_remessa}`} text="XML Remessa" />
            </>
          )}
        </Flex>
      </Td>
    </Tr>
  )
}
